
import SamplingPointListComponent from "@/components/samplingPoints/SamplingPointList.component.vue";
import SamplingPointMapComponent from "@/components/samplingPoints/SamplingPointMap.component.vue";
import PageButtonsComponent from "@/components/PageButtons.component.vue";
import { ElMessage } from "element-plus";
import { defineComponent, ref } from "vue";
import { SamplingPoint } from "@/types/samplingpoint.type";
import SamplingPointFormComponent from "@/components/samplingPoints/SamplingPointForm.component.vue";

import securityService from "@/service/security.service";
import { AppType } from "@/types/app.type";
import { getAvailableRoutes } from "@/service/user.service";
import { RootState } from "@/types/state.type";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  components: {
    SamplingPointListComponent,
    SamplingPointFormComponent,
    SamplingPointMapComponent,
    PageButtonsComponent,
  },
  setup() {
    const isAppAdmin = securityService.isApp(AppType.ADMIN);
    const appIsAdminAndRoleIsAdmin = isAppAdmin && securityService.canAccessToApp(AppType.ADMIN);
    const listCanWrite = appIsAdminAndRoleIsAdmin;
    const canCreate = appIsAdminAndRoleIsAdmin;

    const showMap = ref(securityService.isApp(AppType.ADMIN) ? false : true);
    return {
      appIsAdminAndRoleIsAdmin,
      listCanWrite,
      canCreate,
      showMap,
    };
  },
  data() {
    return {
      showEntityForm: false,
      entityForm: undefined as undefined | SamplingPoint,
    };
  },
  async mounted() {
    const store = useStore<RootState>();
    const route = useRoute();
    const router = useRouter();

    if (store.state.auth.user?.id) {
      try {
        let userRoutes = await getAvailableRoutes(store.state.auth.user.id);
        if (userRoutes.length > 0 && !userRoutes.includes(route.path)) {
          router.push("/admin/upload");
        }
      } catch (error) {
        console.error("Error fetching routes:", error);
      }
    }
  },
  methods: {
    /**
     * open samplingPoints formDialog
     * @param item
     */
    openEntityFormDialog(item: SamplingPoint | undefined = undefined) {
      this.entityForm = item;
      this.showEntityForm = true;
    },

    /**
     * close samplingPoints formDialog
     */
    closeEntityFormDialog() {
      this.showEntityForm = false;
      this.entityForm = undefined;
    },

    /**
     * save samplingPoints
     */
    async saveEntity() {
      // - call samplingPointForm save method
      await (this.$refs["entityForm"] as InstanceType<typeof SamplingPointFormComponent>)
        .doSave()
        .then(() => {
          // - close dialog and refresh
          this.closeEntityFormDialog();
          (
            this.$refs["entityList"] as InstanceType<typeof SamplingPointListComponent>
          ).refreshEntities();
          ElMessage.success(this.$t("success.action"));
        });
    },
    changeView() {
      this.showMap = !this.showMap;
    },
  },
});
